import { render } from "./VendorIndex.vue?vue&type=template&id=6a95ec3f&scoped=true"
import script from "./VendorIndex.vue?vue&type=script&lang=js"
export * from "./VendorIndex.vue?vue&type=script&lang=js"

import "./VendorIndex.vue?vue&type=style&index=0&id=6a95ec3f&scoped=true&lang=css"
import "./VendorIndex.vue?vue&type=style&index=1&id=6a95ec3f&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a95ec3f"]])

export default __exports__